import { reactive } from "vue";
import {
  MAX_MARKS_DEFAULT,
  RANDOM_PAGE_COUNT_DEFAULT,
} from "@modules/editor/service/editor.constant.ts";

export default {
  state: reactive({
    quiz: {},
    editingQuizByUuid: {},
  }),

  /**
   * getter method
   */
  getEditingQuizByUuid(uuid) {
    return this.state.editingQuizByUuid[uuid];
  },
  isLoading(quizUuid) {
    return this.state.quiz[quizUuid].loading;
  },

  /**
   * mutation method
   */
  setLoadingState(quizUuid, loading) {
    const state = this.state.quiz[quizUuid];
    this.state.quiz[quizUuid] = {
      ...state,
      loading: loading,
    };
  },
  addEditingQuiz(payload) {
    this.state.editingQuizByUuid[payload.uuid] = payload;
  },
  /**
   * Reset all randomise settings to default value
   * @param {String} uuid editing quiz uuid
   */
  resetEditingQuizRandomisedSettings(uuid) {
    this.state.editingQuizByUuid[uuid] = {
      ...this.state.editingQuizByUuid[uuid],
      randomPage: false,
      randomByPageCount: false,
      randomPageCount: RANDOM_PAGE_COUNT_DEFAULT.INPUT,
      maxScore: MAX_MARKS_DEFAULT.INPUT,
    };
  },
};
